import { useDispatch } from "react-redux";
import { student_routes } from "../../../feature-module/router/all_routes";
import { setMobileSidebar } from "../../data/redux/sidebarSlice";
import { Link } from "react-router-dom";

const StudentIconMenu = () => {
  const routes = student_routes;

  const dispatch = useDispatch();

  return (
    <>
      <div className="col-6 col-md-4 mb-1">
        <Link
          to={routes.studentEDT}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-success-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-success rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-success rounded-circle">
              <i className="ti ti-calendar" />
            </span>
          </div>
          <p className="text-dark">EDT</p>
        </Link>
      </div>
      <div className="col-6 col-md-4 mb-1">
        <Link
          to={routes.studentCourse}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-secondary-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-secondary rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-secondary rounded-circle">
              <i className="ti ti-license" />
            </span>
          </div>
          <p className="text-dark">Mes Cours</p>
        </Link>
      </div>
      <div className="col-6 col-md-4 mb-1">
        <Link
          to={routes.studentNote}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-primary-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-primary rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-primary rounded-circle">
              <i className="ti ti-hexagonal-prism" />
            </span>
          </div>
          <p className="text-dark">Mes Notes</p>
        </Link>
      </div>
      <div className="col-6 col-md-4 mb-1">
        <Link
          to={routes.studentAttendance}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-warning-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-warning rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-warning rounded-circle">
              <i className="ti ti-calendar-share" />
            </span>
          </div>
          <p className="text-dark">Absences</p>
        </Link>
      </div>
      <div className="col-6 col-md-4 mb-1">
        <Link
          to={routes.myExams}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-secondary-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-secondary rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-secondary rounded-circle">
              <i className="ti ti-license" />
            </span>
          </div>
          <p className="text-dark">Examens</p>
        </Link>
      </div>
      <div className="col-6 col-md-4 mb-1">
        <Link
          to={routes.paymentList}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-success-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-success rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-success rounded-circle">
              <i className="ti ti-cash" />
            </span>
          </div>
          <p className="text-dark">Paiements</p>
        </Link>
      </div>
      <div className="col-6 col-md-4 mb-1">
        <Link
          to={routes.requestList}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-warning-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-warning rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-warning rounded-circle">
              <i className="ti ti-file-text" />
            </span>
          </div>
          <p className="text-dark">Demandes</p>
        </Link>
      </div>
      <div className="col-6 col-md-4 mb-1">
        <Link
          to={routes.myClaims}
          onClick={() => dispatch(setMobileSidebar(false))}
          className="d-block bg-danger-transparent ronded p-2 text-center mb-3 class-hover"
        >
          <div className="avatar avatar-lg border p-1 border-danger rounded-circle mb-2">
            <span className="d-inline-flex align-items-center justify-content-center w-100 h-100 bg-danger rounded-circle">
              <i className="ti ti-alert-circle" />
            </span>
          </div>
          <p className="text-dark">Réclamations</p>
        </Link>
      </div>
    </>
  );
};

export default StudentIconMenu;
